module.exports = __webpack_public_path__ + "img/legend.b1b22954.png";